/* ============================================================
   tio-incluye.js — Abre y cierra el cajon "Que incluye"
   13-sep-2026 · v2

   POR QUE EXISTE. El cajon es un <details> de verdad, para que funcione
   sin JavaScript y para que el lector de pantalla lo anuncie como lo que
   es. Pero <details> NO RENDERIZA su contenido mientras esta cerrado, y
   un elemento que no existe no puede animarse: al abrir, el navegador
   salta directo al estado final. Este archivo se mete en medio de esa
   transicion y la hace correr.

   ABRIR:  se pone `open` (el contenido ya existe), se fuerza a 0fr, se
           deja pasar un fotograma y se suelta -> anima hasta 1fr.
   CERRAR: se anima a 0fr PRIMERO y solo al terminar se quita `open`.
           Si se quitara antes, el contenido desapareceria de golpe.

   ⚠️ NADA DE ESTO PUEDE DEJAR EL CAJON TRABADO. La v1 limpiaba la clase
   `is-abriendo` solo desde requestAnimationFrame y ademas se negaba a
   atender clics mientras esa clase estuviera puesta. Si el rAF no corre
   —pestaña en segundo plano, el sistema cambiando de app, el navegador
   throttleando— la clase se queda pegada y el cajon deja de responder
   PARA SIEMPRE. Se reprodujo midiendo con el navegador de pruebas, que
   congela las transiciones: el segundo clic no cerraba nunca.
   Ahora: (1) toda clase temporal se limpia tambien por setTimeout, que
   corre aunque no se pinte, y (2) ningun clic se ignora — se cancela lo
   que hubiera en curso y se hace caso al cliente.

   El contador `_tioTurno` invalida los callbacks de un cierre que quedo
   a medias: sin el, un cierre viejo podria terminar cerrando un cajon
   que el cliente acaba de volver a abrir.

   SIN ESTE ARCHIVO el cajon sigue abriendo y cerrando: pierde la
   animacion, nada mas. Nunca queda a medias.

   Listeners DELEGADOS en document (doctrina 8.1): el Quick View se
   inyecta y se destruye, asi que un handler por elemento moriria con el
   nodo.
   ============================================================ */
(function () {
  'use strict';

  if (window.__tioIncluye) return;
  window.__tioIncluye = true;

  /* Duracion real de la transicion, leida del CSS. Si el cliente pidio
     reducir movimiento vale 0: no hay `transitionend` que esperar y el
     cierre tiene que ser inmediato en vez de quedarse colgado. */
  function duracion(caja) {
    var v = (getComputedStyle(caja).transitionDuration || '0s').split(',')[0].trim();
    var n = parseFloat(v) || 0;
    return v.slice(-2) === 'ms' ? n : n * 1000;
  }

  function limpiar(det) {
    det.classList.remove('is-abriendo');
    det.classList.remove('is-cerrando');
  }

  function abrir(det, caja) {
    det._tioTurno = (det._tioTurno || 0) + 1;
    limpiar(det);

    det.open = true;
    det.classList.add('is-abriendo');
    /* Leer una medida fuerza el reflow: sin esto el navegador agrupa el
       `open` y el quite de la clase en un solo paso y no anima nada. */
    void caja.offsetHeight;

    var soltar = function () { det.classList.remove('is-abriendo'); };
    if (window.requestAnimationFrame) requestAnimationFrame(soltar);
    /* La red que faltaba en la v1: setTimeout corre aunque el navegador
       no este pintando. Si el rAF llega primero, esto no hace nada. */
    setTimeout(soltar, 80);
  }

  function cerrar(det, caja) {
    var mi = det._tioTurno = (det._tioTurno || 0) + 1;
    limpiar(det);

    var ms = duracion(caja);
    det.classList.add('is-cerrando');

    if (ms < 20) {
      det.classList.remove('is-cerrando');
      det.open = false;
      return;
    }

    var hecho = false;
    var terminar = function (e) {
      if (e && e.propertyName !== 'grid-template-rows') return;
      if (hecho) return;
      hecho = true;
      caja.removeEventListener('transitionend', terminar);
      /* Si el cliente reabrio mientras esto cerraba, el turno cambio y
         este cierre ya no manda. */
      if (mi !== det._tioTurno) return;
      det.classList.remove('is-cerrando');
      det.open = false;
    };

    caja.addEventListener('transitionend', terminar);
    setTimeout(terminar, ms + 120);
  }

  document.addEventListener('click', function (e) {
    var bar = e.target.closest ? e.target.closest('.qinc__bar') : null;
    if (!bar) return;

    var det = bar.parentNode;
    if (!det || det.tagName !== 'DETAILS') return;

    var caja = det.querySelector('.qinc__wrap');
    if (!caja) return;   /* sin envoltorio, que actue el <details> nativo */

    e.preventDefault();

    /* Se atiende SIEMPRE. Si habia una animacion a medias, se cancela y
       se hace lo que el cliente acaba de pedir. */
    if (det.open && !det.classList.contains('is-cerrando')) cerrar(det, caja);
    else abrir(det, caja);
  });
})();
